import React from 'react';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  State,
  coreActions,
  coreSelectors,
  PersonalProperty,
} from '@gymcloud/core';

import {
  updateItemPositonOnList,
} from 'web-utils';

import {
  Button,
  ContentWrapper,
  PersonalProperties,
} from 'web-components';

import {
  Flex,
  Text,
  TextBreadcrumbs,
} from 'web-styled';

const resourceType = 'personalProperties';
const mapState = (state: State) => ({
  properties: coreSelectors.getAllSortedProperties(state),
});

const PersonalPropertiesPage = () => {
  const { properties } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();

  const handleChangeVisible = (property: PersonalProperty) => {
    dispatch(
      coreActions.requestUpdateEntity({
        id: property.id,
        payload: {
          is_visible: !property.is_visible,
        },
        endNotify: true,
        resourceType,
      }),
    );
  };

  const handleDragEnd = ({ source, destination, draggableId }: any) => {
    // dropped outside the list
    if (!destination) {
      return;
    }

    // same position
    if (source.index === destination.index) {
      return;
    }

    const target: any = {
      id: +draggableId,
    };

    const newList = Array.from(
      properties.filter(p => p.id !== +draggableId),
    );

    newList.splice(destination.index, 0, target);

    const resources = updateItemPositonOnList(newList);

    dispatch(
      coreActions.updateResources({
        resourceType,
        resources,
      }),
    );

    dispatch(
      coreActions.requestUpdateItems({
        resources,
        resourceType,
      }),
    );
  };

  return (
    <ContentWrapper
      header={(
        <Flex
          fillSpace
          align="center"
          justify="space-between"
        >
          <TextBreadcrumbs>
            Metrics
          </TextBreadcrumbs>
          <Flex
            align="center"
            spacing={10}
          >
            <Text color="#969696">Not Enough?</Text>
            <Button
              ghost
              as="a"
              rel="noopener noreferrer"
              href="https://gymcloud.freshdesk.com/support/tickets/new"
              target="_blank"
              appearance="primary"
            >
              Suggest a Metric
            </Button>
          </Flex>
        </Flex>
      )}
    >
      <PersonalProperties
        properties={properties}
        onDragEnd={handleDragEnd}
        onChangeVisible={handleChangeVisible}
      />
    </ContentWrapper>
  );
};

export default PersonalPropertiesPage;
